module.exports = __webpack_public_path__ + "static/img/son5_active.97a17369.png";